import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function PrivateRoute({ children, adminOnly = false, sellerOnly = false, allowedRoles = [] }) {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>로딩 중...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    // 관리자/판매자 페이지는 관리자 로그인으로 리다이렉트.
    // 원래 목적지를 state 로 보존한다 — 알림톡의 관리자 딥링크(/admin/orders?orderId=N)로
    // 들어온 미로그인 관리자가 로그인 후 대시보드가 아니라 해당 주문으로 가야 한다.
    if (adminOnly || sellerOnly) {
      return <Navigate to="/adminlogin" state={{ from: location }} replace />;
    }
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (adminOnly && user.role !== 'ADMIN') {
    return <Navigate to="/" />;
  }

  if (sellerOnly && user.role !== 'SELLER') {
    return <Navigate to="/" />;
  }
  
  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" />;
  }

  return children;
}

export default PrivateRoute;

